/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { useQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import mbpLogger from '@module-logger/mbp';
import { GRAPHQL_ENV } from '../../../../gql';
import findContent from '../../../../gql/queries/findContent';

const useStyles = makeStyles((theme) => ({
    yotpoReviewLegalCopyContainer: {
        maxWidth: '980px',
        margin: '46px auto 46px auto',
        [theme.breakpoints.down(960)]: {
            margin: '30px 10px',
        },
        '& p': {
            fontSize: '14px',
        },
    },
    legalCopySkeleton: {
        height: '88px',
        [theme.breakpoints.down(771)]: {
            height: '108px',
        },
        [theme.breakpoints.down(600)]: {
            height: '128px',
        },
        [theme.breakpoints.down(425)]: {
            height: '148px',
        },
        [theme.breakpoints.down(360)]: {
            height: '168px',
        },
    },
}));

const YotpoReviewsLegalCopy = () => {
    const classes = useStyles();

    const YOTPO_LEGAL_COPY = findContent({
        brand: 'global',
        contentType: 'yotpo_legal_copy_pdp',
    });

    const { data, error, loading } = useQuery(YOTPO_LEGAL_COPY);

    if (loading) {
        return <div className={classes.legalCopySkeleton} />;
    }

    if (error) {
        mbpLogger.logError({
            query: YOTPO_LEGAL_COPY,
            component: 'YotpoReviewsLegalCopy.js',
            message: 'No data or error returned for query',
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }

    if (data?.findContent?.content?.entries?.length === 0) {
        return null;
    }

    const legalCopy = data.findContent.content?.entries[0]?.copy;
    if (legalCopy) {
        return (
            <div className={classes.yotpoReviewLegalCopyContainer}>
                <p>
                    {legalCopy}
                </p>
            </div>
        );
    }
    return null;
};

export default YotpoReviewsLegalCopy;
